import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL;

// Create axios instance with default config
const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Client Partner API Service (Single Type)
export const clientPartnerService = {
  // Get client partner page data (Single Type - returns single object)
  async getClientPartnerData(params = {}) {
    try {
      // Use simple API call - the controller will handle proper populate
      const response = await api.get('/clinets-page');
      // For Single Types, the data is directly in response.data.data
      return {
        data: response.data.data,
        meta: response.data.meta,
        success: true
      };
    } catch (error) {
      console.error('Error fetching client partner data:', error);
      console.error('Error details:', error.response?.data);
      console.error('Error status:', error.response?.status);
      console.error('Error message:', error.message);
      
      return {
        data: null,
        success: false,
        error: error.response?.data?.error?.message || error.message || 'Failed to fetch client partner data'
      };
    }
  }
};

// Helper function to format image URLs (same as contactService)
export const formatImageUrl = (imageData) => {
  if (!imageData) return null;
  
  // Use base Strapi URL (without /api) for images
  const baseUrl = process.env.REACT_APP_API_URL?.replace('/api', '');
  
  if (typeof imageData === 'object' && imageData.url) {
    return imageData.url.startsWith('http') ? imageData.url : `${baseUrl}${imageData.url}`;
  }
  
  return null;
};

// Helper function to format client partner data
export const formatClientPartnerData = (clientPartnerData) => {
  if (!clientPartnerData) return null;

  return {
    ...clientPartnerData,
    // Format client header with header image
    clientHeader: clientPartnerData.clientHeader ? {
      ...clientPartnerData.clientHeader,
      headerImage: clientPartnerData.clientHeader.headerImage ? {
        ...clientPartnerData.clientHeader.headerImage,
        url: formatImageUrl(clientPartnerData.clientHeader.headerImage),
      } : null,
    } : null,
    
    // Format title description (already simple fields)
    titleDesc: clientPartnerData.titleDesc,
    
    // Format client sections with client images
    clientSections: clientPartnerData.clientSections?.map(section => ({
      ...section,
      // Format client images from gallery components
      clientImages: section.clientImages?.map(clientItem => ({
        ...clientItem,
        // Access the images field within the gallery component
        url: formatImageUrl(clientItem.images),
        alt: clientItem.images?.alternativeText || clientItem.title || 'Client Logo',
      })) || [],
    })) || [],
  };
};

export default clientPartnerService;
